import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67d97fcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "filter__buttons" }
const _hoisted_3 = ["onClick"]

import { useI18n } from 'vue-i18n';
import SearchSwitch from '@/components/inputs/SearchSwitch.vue';
import { FilterButton } from '@/types/LabData';


export default /*#__PURE__*/_defineComponent({
  __name: 'Filter',
  props: {
    filterSections: {},
    countLicense: {},
    hasLicense: { type: Boolean },
    filterWord: {},
    isNotFound: { type: Boolean }
  },
  emits: ["update:group", "update:search", "update:license"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useI18n();

// METHODS
const addActive = (key: string) => {
  emit('update:group', key);
};

const handleSearchInput = (val: string) => {
  emit('update:search', val);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchSwitch, {
      value: _ctx.filterWord || '',
      isNotFound: _ctx.isNotFound,
      placeholder: _unref(t)('search'),
      useInputEvent: "",
      onInput: handleSearchInput
    }, null, 8, ["value", "isNotFound", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.countLicense)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["toggle__btn filter__active", { checked: _ctx.hasLicense }]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:license', !_ctx.hasLicense);})
          }, [
            _createTextVNode(_toDisplayString(_unref(t)('activeLicense')) + " ", 1),
            _createElementVNode("span", null, " (" + _toDisplayString(_ctx.countLicense) + ") ", 1)
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSections.values(), (button, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: `btn-${index}`,
          class: _normalizeClass(['toggle__btn', { active: button?.active }]),
          type: "button",
          onClick: ($event: any) => (addActive(button.shortname))
        }, [
          _createTextVNode(_toDisplayString(button?.name) + " ", 1),
          _createElementVNode("span", null, " (" + _toDisplayString(button.count) + ") ", 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})